import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

function CompanyCard({ img, sub, title, des }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Card sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" } }}>
        <CardMedia
          component="img"
          sx={{ 
            width: { xs: "100%", sm: "150px" }, 
            height: { xs: "auto", sm: "100%" }, 
            objectFit: "cover" 
          }}
          image={img}
          alt={title}
        />
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <CardContent sx={{ flex: "1 0 auto" }}>
            <Typography component="div" variant="h5">
              {title}
            </Typography>
            <Typography
              variant="subtitle1"
              component="div"
              sx={{ color: "text.secondary" }}
            >
              {sub}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {des}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between", padding: "15px 15px 0 15px" }}>
              <Typography variant="body2" sx={{ color: "blue" }}>
                <a href="https://ignosi.in/" target="_blank" rel="noopener noreferrer">ignosi.in</a>
              </Typography>
              <Typography variant="body2" sx={{ color: "blue", cursor: "pointer" }}>
              <p  onClick={(e) => { e.preventDefault(); handleClickOpen(); }}>What I did?</p>
              </Typography>
            </Box>
          </CardContent>
        </Box>
      </Card>

      {/* Modal for "What I did?" Details */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Ignosi Enterprises</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <strong>Duration:</strong> 2024-2025 <br />
            <strong>Position:</strong> Developer (CodeIgniter PHP) <br />
            <strong>Technologies Used:</strong> Semantic UI, jQuery, AJAX <br />
            <strong>Projects Worked On:</strong>
            <ul>
              <li><strong>Nidhi & FPC:</strong> Finance software with payment gateway integration</li>
              <li><strong>Zeego:</strong> E-commerce website with APIs like Ecom Express</li>
            </ul>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CompanyCard;
